import { IEnvironment } from './environment.interface';
import { STAGE_API_URLS } from '@k12/api-environment';

export const environment: IEnvironment = {
  adminApiUrl: 'https://staging-api-enrollment.azure-api.net',
  enrollmentUrl: '/staging-api-enrollment',
  appUrl: 'https://schools-staging-frontend-dkbugecgetf5apgb.z02.azurefd.net',
  providerAppUrl: 'https://providers-staging-frontend-ckbjh8g4azf5e9ey.z02.azurefd.net',
  enrollmentToken: 'JarH2TlnYRWwY1rq',
  name: 'staging',
  production: false,
  subscriptionKey: '19255064478c4c69959ade98e73d2ae8',
  msalClientId: '5ee5c83e-f7ec-4439-9290-6ae7f4474100',
  msalAuthority: 'https://cfncnet.ciamlogin.com/4d0b1d13-40fc-479b-870b-9f17bf4b23b6',
  metabaseInstanceUrl: 'https://keen-hake.metabaseapp.com',
  instrumentationKey: '2131bbb8-5175-494b-8c3a-ed6c22229e70',
  app: 'schools',
  apiMode: 'split',
  apiUrls: STAGE_API_URLS
};
